import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateInventoryTransactionStatusReduxParams } from '~types/feat/approval';

import { TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateInventoryTransactionStatusModal.module.scss';

const ConfirmUpdateInventoryTransactionStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateInventoryTransactionStatusModalIsOpen);
    const tempUpdateInventoryTransactionState = useAppSelector(state => state.approval.tempUpdateInventoryTransactionState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateInventoryTransactionStatus);
    const error = useAppSelector(state => state.approval.errors.updateInventoryTransactionStatus);

    const getStatus = () => {
        switch (tempUpdateInventoryTransactionState.status) {
            case (TransactionStatusEnum.Approved): return 'Approve';
            case (TransactionStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateInventoryTransactionStatusModalIsOpen(open));
    const updateInventoryTransactionStatus = (data: TUpdateInventoryTransactionStatusReduxParams) => dispatch(combinedActions.approvalUpdateInventoryTransactionStatusAttempt(data));

    const handleSubmitClick = () => {
        updateInventoryTransactionStatus(tempUpdateInventoryTransactionState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateInventoryTransactionStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            testId='approval-confirmInventory-modal-close'
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Inventory?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    testId='approval-goldInventory-table-cancel-button'
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    testId='approval-goldInventory-table-approveReject-button'
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateInventoryTransactionStatusModal;
